export const Effects = {
  smallElementsShadow: "0px 10px 30px -5px rgba(0, 0, 0, 0.1)",
  blockShadow: "0px 20px 80px rgba(0, 0, 0, 0.1)",
};
